function boundedNumber(value, label, minimum, maximum, integer = false) {
  const number = Number(value);
  if (!Number.isFinite(number) || number < minimum || number > maximum || (integer && !Number.isInteger(number))) {
    throw new Error(`${label} must be between ${minimum} and ${maximum}.`);
  }
  return number;
}

export function normalizeDeviceSettings(input) {
  const maximumTemperature = boundedNumber(input.maximumTemperature, "Maximum temperature", -55, 125);
  const minimumTemperature = input.minimumTemperature === "" || input.minimumTemperature === null || input.minimumTemperature === undefined
    ? null
    : boundedNumber(input.minimumTemperature, "Minimum temperature", -55, 125);
  if (minimumTemperature !== null && minimumTemperature >= maximumTemperature) throw new Error("Minimum temperature must be below the maximum temperature.");
  return {
    maximum_temperature_c: maximumTemperature,
    minimum_temperature_c: minimumTemperature,
    alert_delay_minutes: boundedNumber(input.alertDelay, "Alert delay", 1, 240, true),
    measurement_interval_seconds: boundedNumber(input.measurementInterval, "Measurement interval", 10, 3600, true),
    logging_interval_seconds: boundedNumber(input.loggingInterval, "Logging interval", 60, 86400, true),
    heartbeat_interval_seconds: boundedNumber(input.heartbeatInterval, "Cloud update interval", 15, 3600, true),
    relay_enabled: Boolean(input.relayEnabled),
  };
}

export function deviceSettingsApplied(device) {
  return Number(device.settings_applied_revision ?? 0) >= Number(device.settings_revision ?? 1);
}

export function readRequestPending(device) {
  if (!device.read_request_id || !device.read_requested_at) return false;
  return !device.read_completed_at || new Date(device.read_completed_at).getTime() < new Date(device.read_requested_at).getTime();
}
